import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { PropsWithChildren } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useTitle } from 'shared/hooks';
import { AuthInProgress } from 'shared/providers';

const styles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 2,
    alignItems: 'center',
    padding: 2,
    height: '200px',
};

function Div({ children }: PropsWithChildren<{}>) {
    return <Box sx={styles}>{children}</Box>;
}

export function LoginPage() {
    useTitle('Belnick PMT Login');
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const { instance, inProgress } = useMsal();

    const login = async () => {
        try {
            await instance.loginRedirect();
            history.push(ROUTES.products);
        } catch (error: any) {
            enqueueSnackbar(error.message, { variant: 'error' });
        }
    };
    if (
        inProgress !== InteractionStatus.None &&
        inProgress !== InteractionStatus.Startup &&
        (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect)
    ) {
        // TODO better auth in progress ui
        return (
            <Div>
                <AuthInProgress />
            </Div>
        );
    }

    return (
        <>
            <AuthenticatedTemplate>
                <Redirect to={ROUTES.products} />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <Div>
                    <Typography textAlign='center' variant='h3'>
                        Belnick DTC Dynamic Price Management
                    </Typography>
                    <Button size='large' variant='contained' color='primary' onClick={login}>
                        Login
                    </Button>
                </Div>
            </UnauthenticatedTemplate>
        </>
    );
}
